import { render, staticRenderFns } from "./ModelViewerView.vue?vue&type=template&id=122ac01e&scoped=true"
import script from "./ModelViewerView.vue?vue&type=script&lang=js"
export * from "./ModelViewerView.vue?vue&type=script&lang=js"
import style0 from "./ModelViewerView.vue?vue&type=style&index=0&id=122ac01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ac01e",
  null
  
)

export default component.exports